import { useMutation, useQueryClient } from "@tanstack/react-query";
import { markFallbackDefault } from "@/api/form-builder/formBuilder.mutations";
import { FormBuilderQueryKeys } from "@/api/form-builder/formBuilder.queries";
import { handleApiError, handleApiSuccess } from "@/utils/responseHandler";
import type { ApiError } from "@/types/common.types";

export const useMarkFallbackDefault = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (formId: string) => markFallbackDefault(formId),
    onSuccess: () => {
      handleApiSuccess("Form marked as the fallback default");
      queryClient.invalidateQueries({ queryKey: [FormBuilderQueryKeys.list] });
      queryClient.invalidateQueries({ queryKey: [FormBuilderQueryKeys.detail] });
    },
    onError: (error) => handleApiError(error as ApiError, "Failed to set fallback default"),
  });
};
